import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">关于我们</h2>
          </div>

          <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutData.paragraphs.map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          <div className="flex flex-wrap justify-center gap-8 mt-10 pt-8 border-t border-background-200">
            <div className="text-center">
              <div className="text-xl font-bold text-primary-500">2019</div>
              <div className="text-xs text-foreground-400 mt-1">创立年份</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-bold text-primary-500">30,000+</div>
              <div className="text-xs text-foreground-400 mt-1">收录剧集</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-bold text-primary-500">5,000万+</div>
              <div className="text-xs text-foreground-400 mt-1">累计观众</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}